import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const LegendWrapperStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  gap: '16px',
});

export const LegendItemStyled = styled(Box)({
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
  fontSize: '14px',
});

export const TooltipTitleStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '12px',
  gap: '4px',
});

export const LegendItemDotStyled = styled(Box)({
  width: '12px',
  height: '12px',
  borderRadius: '100%',
  backgroundColor: 'grey',
});
